import { DatePicker, Form, Input, InputNumber, Select } from "antd";
import type { Dayjs } from "dayjs";
import { usePlantList } from "../hooks/usePlants";

interface PlantContractFormProps {
	organizationId?: string;
}

export function PlantContractForm({ organizationId }: PlantContractFormProps) {
	const { data: plantsData } = usePlantList({
		organizationId: organizationId ?? "",
		page: 1,
		limit: 100,
	});
	const plants = plantsData?.data?.items ?? [];

	return (
		<>
			<Form.Item name="organizationId" hidden>
				<Input />
			</Form.Item>
			<div className="grid grid-cols-2 gap-4">
				<Form.Item
					name="plantId"
					label="O'simlik"
					rules={[{ required: true, message: "O'simlikni tanlang" }]}
				>
					<Select
						placeholder="O'simlikni tanlang"
						showSearch
						filterOption={(input, option) =>
							(option?.label as string)?.toLowerCase().includes(input.toLowerCase())
						}
						options={plants.map((p) => ({ value: p.id, label: p.name }))}
					/>
				</Form.Item>
				<Form.Item
					name="supplierName"
					label="Yetkazib beruvchi"
					rules={[
						{ required: true, message: "Yetkazib beruvchi nomini kiriting" },
						{ max: 255, message: "Maksimum 255 ta belgi" },
					]}
				>
					<Input placeholder="Masalan: Yashil Bog' MChJ" size="middle" />
				</Form.Item>
				<Form.Item
					name="contractNumber"
					label="Shartnoma raqami"
					rules={[{ max: 255, message: "Maksimum 255 ta belgi" }]}
				>
					<Input placeholder="Masalan: SH-2026/14" size="middle" />
				</Form.Item>
				<Form.Item name="price" label="Narx">
					<InputNumber
						className="w-full"
						placeholder="Masalan: 150000"
						min={0}
						precision={2}
						stringMode
						addonAfter="so'm"
					/>
				</Form.Item>
				<Form.Item name="quantity" label="Soni">
					<InputNumber className="w-full" placeholder="Masalan: 500" min={1} precision={0} />
				</Form.Item>
				<Form.Item name="startDate" label="Boshlanish sanasi">
					<DatePicker className="w-full" format="DD.MM.YYYY" placeholder="Sanani tanlang" />
				</Form.Item>
				<Form.Item
					name="endDate"
					label="Tugash sanasi"
					dependencies={["startDate"]}
					rules={[
						({ getFieldValue }) => ({
							validator(_, value: Dayjs | undefined) {
								const start = getFieldValue("startDate") as Dayjs | undefined;
								if (!(value && start && value.isBefore(start, "day"))) {
									return Promise.resolve();
								}
								return Promise.reject(
									new Error("Tugash sanasi boshlanish sanasidan oldin bo'lishi mumkin emas")
								);
							},
						}),
					]}
				>
					<DatePicker className="w-full" format="DD.MM.YYYY" placeholder="Sanani tanlang" />
				</Form.Item>
			</div>
		</>
	);
}
